import { CardI } from '../../../shared/interfaces/card.interface';

export const DepartmentsCards: CardI[] = [
  {
    icon: 'course',
    number: 0,
    text: 'programs.cards.totalCourses',
  },
  {
    icon: 'student',
    number: 0,
    text: 'programs.cards.totalStudents',
  },
  {
    icon: 'instructor',
    number: 0,
    text: 'programs.cards.totalInstructors',
  },
];
